"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERNAL_HOOKS = exports.EXPAND_COLUMN = void 0;
var EXPAND_COLUMN = exports.EXPAND_COLUMN = {};
var INTERNAL_HOOKS = exports.INTERNAL_HOOKS = 'rc-table-internal-hook';